<template>
  <section class="preview">
    <div>
      <mdb-modal fullHeight position="top" :show="modalCreative" @close="modalCreative = false">
        <mdb-modal-header>
          <mdb-modal-title class="pl-4">Crear creative Ad</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <form novalidate @submit.prevent="crearCreative()">
            <b-row>
                <b-col lg="6">
                  <div class="form-group">
                    <label class="typo__label">Nombre creative</label>
                    <input type="text" class="form-control" placeholder="Nombre" v-model="ad_creative.name" />
                  </div>
                </b-col>
                <b-col lg="6">
                  <div class="form-group">
                    <label class="typo__label">URL de anuncio</label>
                    <input type="text" class="form-control" placeholder="URL" v-model="ad_creative.link_data" />
                  </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="typo__label">Descripción</label>
                    <input type="text" class="form-control" placeholder="Descripción" v-model="ad_creative.description" />
                  </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                  <div class="form-group">
                    <label class="typo__label">Cuenta</label>
                    <multiselect
                      v-model="ad_creative.account_id"
                      :options="accounts"
                      placeholder="Cuenta"
                      label="name"
                      track-by="id"
                    ></multiselect>
                  </div>
                </b-col>
                <b-col lg="6">
                  <div class="form-group">

                    <label class="typo__label">Tipo de multimedia</label>
                    <multiselect
                      v-model="ad_creative.resource_type"
                      :options="resources"
                      placeholder="Tipo de multimedia"
                      label="label"
                      track-by="value"
                    ></multiselect>
                  </div>
                </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                  <div class="form-group">
                    <label for="exampleFormControlFile1">Imagen o video</label>
                    <input
                      type="file"
                      class="form-control-file"
                      accept=".png, .jpg, .jpeg,video/mp4,video/x-m4v,video/*"
                      id='file-preview-input'
                      @change="previewFiles()"
                    />
                  </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                  <div class="form-group">
                    <label for="exampleFormControlFile1">Imagen o video Horizontal</label>
                    <input
                      type="file"
                      class="form-control-file"
                      accept=".png, .jpg, .jpeg,video/mp4,video/x-m4v,video/*"
                      id='file-preview-input-horizontal'
                      @change="previewFilesHorizontal()"
                    />
                  </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                  <div class="form-group">
                    <label for="exampleFormControlFile1">Imagen o video Vertical</label>
                    <input
                      type="file"
                      class="form-control-file"
                      accept=".png, .jpg, .jpeg,video/mp4,video/x-m4v,video/*"
                      id='file-preview-input-vertical'
                      @change="previewFilesVertical()"
                    />
                  </div>
              </b-col>
            </b-row>
            <div class="text-center">
              <mdb-btn type="submit" color="primary" :disabled="isLoadingCreative">
                <span v-if="!isLoadingCreative">Crear creative</span>
                <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoadingCreative"></semipolar-spinner>
              </mdb-btn>
            </div>
          </form>
        </mdb-modal-body>
      </mdb-modal>
    </div>

    <form novalidate @submit.prevent="crear">
      <div class="row">
        <div class="col-8">
            <div>
              <b-row>
                  <b-col lg="6">
                    <div class="form-group">
                      <label class="typo__label">Nombre</label>
                      <input type="text" class="form-control" placeholder="Nombre AD" v-model="ad.name" />
                    </div>
                  </b-col>
                  <b-col lg="6">
                    <div class="form-group">
                      <label class="typo__label">Display URL</label>
                      <input type="text" class="form-control" placeholder="Display AD" v-model="ad.display_url" />
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col lg="12">
                    <div class="form-group">
                      <label class="typo__label">Conjunto de anuncios</label>
                      <multiselect
                        v-model="ad.adset_id"
                        :options="adsets"
                        placeholder="Conjunto de anuncio"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col lg="12">
                    <div class="form-group">
                      <label class="typo__label">Título AD</label>
                      <input type="text" class="form-control" placeholder="Titulo AD" v-model="ad.title" />
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col lg="6">
                    <div class="form-group">
                      <label class="typo__label">Contenido AD</label>
                      <textarea
                        class="form-control"
                        placeholder="Contenido AD"
                        rows="3"
                        v-model="ad.content"
                      ></textarea>
                    </div>
                  </b-col>
                  <b-col lg="6">
                    <div class="form-group">
                      <label class="typo__label">Descripción AD</label>
                      <textarea
                        class="form-control"
                        placeholder="Descripción AD"
                        rows="3"
                        v-model="ad.description"
                      ></textarea>
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col lg="6">
                    <div class="form-group">
                      <label class="typo__label">Tipo de AD</label>
                      <multiselect
                        v-model="ad.type"
                        :options="typeAds"
                        placeholder="tipo"
                        label="name"
                        track-by="id"
                      ></multiselect>
                    </div>
                  </b-col>
                  <b-col lg="6">
                    <div class="form-group">
                      <label class="typo__label">Call to action</label>
                      <multiselect
                        v-model="ad.callToAction"
                        :options="CallToActions"
                        placeholder="Call to action"
                        label="name"
                        track-by="value"
                      ></multiselect>
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                  <!--<b-col lg="12">
                    <div class="form-group">
                      <label for="exampleFormControlFile1">Suba la imagen destacada</label>
                      <input
                        type="file"
                        class="form-control-file"
                        multiple
                        accept=".png, .jpg, .jpeg"
                        :id="'files-'+index"
                        @change="previewFiles(index)"
                      />
                    </div>
                  </b-col>-->
                  <b-col lg="12">
                    <!--<div class="form-group">
                      <label for="exampleFormControlFile1">Suba la imagen destacada</label>
                      <input
                        type="file"
                        class="form-control-file"
                        multiple
                        accept=".png, .jpg, .jpeg,video/mp4,video/x-m4v,video/*"
                        id='files-preview-input'
                        @change="previewFiles()"
                      />
                    </div>-->
                    <div class="form-group">
                      <label class="typo__label">
                        Ad creative
                        <i class="fas fa-plus-circle icono-crear mr-1" @click="OpenmodalCreative()"></i>
                      </label>
                      <multiselect
                        v-model="ad.creative_ids"
                        :options="adsCreatives"
                        placeholder="Call to action"
                        label="name"
                        track-by="id"
                        multiple
                      ></multiselect>
                    </div>
                    <div class="form-group">
                      <label class="typo__label">
                        Status
                      </label>
                      <multiselect
                        v-model="ad.status"
                        :options="all_status"
                        placeholder="Call to action"
                        label="name"
                        track-by="value"
                      ></multiselect>
                    </div>
                    <div class="form-group">
                      <b-form-checkbox
                        id="checkbox-1"
                        v-model="ad.is_political_ad"
                        name="checkbox-1"
                      >
                        ¿Es un ad politico?
                      </b-form-checkbox>
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                    <!--<div class ="col-8 offset-2"> 
                        <mdb-btn color="danger" @click="removeAd(index)">
                          Eliminar
                        </mdb-btn>
                        <mdb-btn color="primary" @click="showAd(index)">
                          Mostrar
                        </mdb-btn>
                        <mdb-btn v-if="index + 1 === ads.length" @click="addAd()" color="success">
                          Agregar
                        </mdb-btn>
                    </div>--> 
              </b-row>
        </div>
        </div>
            <div class="col-4">
              <div class="container preview">
                <b-row class="pl-3 pt-3 pb-1">
                  <b-col lg="2">
                    <div class="bg-dark imagen-perfil"></div>
                  </b-col>
                  <b-col lg="10">
                    <b-row>
                      <b-col lg="10 titulo-empresa">
                        <h1>Empresa</h1>
                        <span class="sponsor">
                          <a
                            href="#"
                          >{{(ad.type.hasOwnProperty("name"))?(ad.type.name):("Título Ad")}}</a>-
                          <i class="fas fa-globe-americas"></i>
                        </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="pl-3 pr-3">
                  <p style="font-size: 13px">
                    {{(ad.content.length)?(ad.content):("Lorem ipsum dolor sit amet consectetur adipisicing elit. pariatur nesciunt doloremque vel odi"
                    + "numquam beatae distinctio")}}
                  </p>
                </b-row>
                <b-row class="pl-3 pr-3">
                  <b-col lg="12" class="bg-dark imagen-destacada">
                    <carousel v-if="ad.files.length > 0" :perPageCustom="[[480, 1], [768, 1]]" :navigationEnabled="true" :paginationEnabled="false" class="contener-completo">
                      <slide v-for="(item,index) in ad.files" :key="index" class="contener-completo" >
                        <div v-if="item.type == 'imagen'" class="contener-completo" >
                          <img :src="item.url" alt="" class="contener-completo">
                        </div>
                        <div v-else class="contener-completo">
                          <video :src="item.url" class="video-component contener-completo" controls >
                          </video>
                        </div>
                      </slide>
                    </carousel>
                    <div id="preview-img">
                      <img v-if="ad.url" :src="ad.url" height="246" class="imagen" />
                    </div>
                  </b-col>
                  <b-col lg="12" class="descripcion-contenedor">
                    <h3 class="addTitle">{{(ad.title.length)?(ad.title):("Título Ad")}}</h3>
                    <p>
                      {{(ad.description.length)?(ad.description):("Lorem ipsum dolor sit amet consectetur adipisicing elit. pariatur nesciunt doloremque vel odi"
                      + "numquam beatae distinctio nam laboriosam eum laborum dignissimos dolores, sunt excepturi.")}}
                    </p>
                    <b-row>
                      <b-col lg="6">
                        <span
                          class="link-anuncio"
                        >{{(ad.display_url)}}</span>
                      </b-col>
                      <div class="offset-2 col-3">
                        <button
                          type="button"
                          class="call-to-action"
                        >{{(ad.callToAction.hasOwnProperty("name"))?(ad.callToAction.name):("Action")}}</button>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="p-3">
                  <b-col lg="12">
                    <ul class="interaccion">
                      <li>200 Likes</li>
                      <li>25 Comments</li>
                      <li>109 Shares</li>
                    </ul>
                  </b-col>
                </b-row>
              </div>
            </div>
      </div>
      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import { SemipolarSpinner } from "epic-spinners";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import store from "../../store";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalTitle,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
export default {
  name: "modal-2",
  components: {
    Multiselect,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
     mdbModalTitle,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbTooltip
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoadingCreative:false,
      modalCreative:false,
      isLoading: false,
      is_value_based:false,
      campaigns:[],
      adsCreatives:[],
      adsets:[],
      accounts:[],
      resources:[
        {value:"image",label:"Image"},
        {value:"video",label:"Video"}
      ],
      all_status: [
        { name: "Activa", value: "ACTIVE" },
        { name: "Pausada", value: "PAUSED" },
        { name: "Eliminada", value: "DELETED" },
        { name: "Archivada", value: "ARCHIVED" }
      ],
      ad: {
          name:"",
          creative_ids:[],
          campaign_id:{},
          display_url:"",
          adset_id:{},
          title: "", //third tab
          content: "",
          description: "",
          type: {},
          callToAction: {},
          files: [],
          url: "",
          status:{},
          is_political_ad: false
        },
      ad_creative:{
        account_id:'',
        name:'',
        description:'',
        resource_type:{},
        link_data:'',
        files:{
          file:false,
          file_h:false,
          file_v:false,
          file_video_thumbnail:false,
          file_video_thumbnail_h:false,
          file_video_thumbnail_v:false,
          file_name:'',
          video_name:''
        }
      },
      typeAds: [
        { name: "App", id: 1 },
        { name: "Instagram", id:  2},
        { name: "Imagén", id: 3 },
        { name: "Vídeo", id: 4 },
        { name: "Carrusel", id: 7 }
      ],
      CallToActions: [
        { name: "Leer más", value: "LEARN_MORE", id:1 },
        { name: "Descargar", value: "DOWNLOAD", id:2 },
        { name: "Contactanos", value: "CONTACT_US", id:3 },
        { name: "Aplicar ahora", value: "APPLY_NOW", id:4 },
        { name: "Descargar en movil", value: "MOBILE_DOWNLOAD",id:7 },
        { name: "Obtener oferta", value: "GET_OFFER",id:8 },
        { name: "Obtener horarios", value: "GET_SHOWTIMES",id:9 },
        { name: "Ver video", value: "WATCH_VIDEO",id:10 },
      ],
    };
  },
  async mounted() {
    //apache.ad.calltoaction
    var test = document.getElementsByClassName("modal-full-height")[0]
    test.style.minWidth = "85%"
    test.style.width = "85%"
    await this.getAdsets();
    await this.getAdAccounts();
    await this.getAdsCreatives();
    await this.getOptimizationGoal();
    await this.getTargets();
  },
  methods: {
    async getAdsets(){
      var adsets = store.getters.getAdsets;
      if (adsets.length == 0) {
          await store.dispatch("getAdsets").then(() => {
            var adsets = store.getters.getAdsets;
            this.adsets = adsets;
          });
      } else {
          this.adsets = adsets;
      }
    },
    async getAdAccounts(){
      var accounts = store.getters.getAdsAccounts;
      if (accounts.length == 0) {
          await store.dispatch("getAdsAccounts").then(() => {
            var accounts = store.getters.getAdsAccounts;
            this.accounts = accounts;
          });
      } else {
          this.accounts = accounts;
      }
    },
    async getAdsCreatives(){
      var adsCreatives = store.getters.getAdsCreatives;
      if (adsCreatives.length == 0) {
          await store.dispatch("getAdsCreatives").then(() => {
            var adsCreatives = store.getters.getAdsCreatives;
            this.adsCreatives = adsCreatives;
          });
      } else {
          this.adsCreatives = adsCreatives;
      }
    },
    async getOptimizationGoal(){
      var optimizationGoals = store.getters.getOptimizationGoal;
      if (optimizationGoals.length == 0) {
        await store.dispatch("getOptimizationGoal").then(() => {
          optimizationGoals = store.getters.getOptimizationGoal;
          this.optimizationGoals = optimizationGoals;
          return;
        });
      } else {
        this.optimizationGoals = optimizationGoals;
        return;
      }
    },
    async getBillingEvents(opcion){
      var id = opcion.id
      await store.dispatch("getBillingEventsParams",id).then(() => {
        var billingEvents = store.getters.getBillingEvents;
        this.billingEvents = billingEvents;
        return;
      });
     
    },
    async getTargets(){
      var targets = store.getters.getStereotypes;
      if (targets.length == 0) {
        await store.dispatch("getStereotypes").then(() => {
          targets = store.getters.getStereotypes;
          this.targets = targets;
          return;
        });
      } else {
        this.targets = targets;
        return;
      }
    },
    async previewFiles() {
      const file =  document.getElementById("file-preview-input").files[0];
      let new_file = '';
      /*let url = URL.createObjectURL(file);
      new_file.url = url;
      new_file.file = file_url*/
      new_file =  await this.getBase64(file).then(
                              data => {
                              return data
                            }
                          );
      
      if(file.type.includes("video")){
        this.ad_creative.files.file_video_thumbnail = new_file;
        this.ad_creative.files.video_name = file.name;
      }else{
        this.ad_creative.files.file = new_file;
        this.ad_creative.files.file_name = file.name;
      }
    },
    async previewFilesHorizontal() {
      const file =  document.getElementById("file-preview-input-horizontal").files[0];
      let new_file = '';
      /*let url = URL.createObjectURL(file);
      new_file.url = url;
      new_file.file = file_url*/
      new_file =  await this.getBase64(file).then(
                              data => {
                              return data
                            }
                          );
        
      if(file.type.includes("video")){
        this.ad_creative.files.file_video_thumbnail_h = new_file;
      }else{
        this.ad_creative.files.file_h = new_file;
      }
    },
    async previewFilesVertical() {
      const file =  document.getElementById("file-preview-input-vertical").files[0];
      let new_file = '';
      /*let url = URL.createObjectURL(file);
      new_file.url = url;
      new_file.file = file_url*/
      new_file =  await this.getBase64(file).then(
                              data => {
                              return data
                            }
                          );
      if(file.type.includes("video")){
        this.ad_creative.files.file_video_thumbnail_v = new_file;
      }else{
        this.ad_creative.files.file_v = new_file;
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    crear(event) {
      creative_ids 
      let creative_ids = [];
      this.ad.creative_ids.map(creative =>{
        creative_ids.push(creative.id);
      })
      this.ad.creative_ids = creative_ids;
      store.dispatch("newAd", this.ad).then(() => {
        this.name=""
        this.onClick();
        this.isLoading = false;
      });
    },
    crearCreative(event){
      this.isLoadingCreative = true;
      store.dispatch("newAdCreatives", this.ad_creative).then(() => {
        this.modalCreative = false;
        this.isLoadingCreative = false;
      });
    },
    OpenmodalCreative(){
      this.modalCreative = true;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.contenedor-preview {
  position: relative;
  height: 700px;
  background: rgb(32, 160, 255);
  border-radius: 10px;
}
.preview {
  position: relative;
  height: auto;
  background: #ffffff;
  color: #929292;
}

.container.preview {
    border: 1px solid #ccc;
    border-radius: 5px;
}

.VueCarousel-wrapper {
    height: 100% !important;
}

.imagen-perfil {
  position: relative;
  height: 50px;
  width: 50px;
  padding: none;
  margin: none;
  left: -40%;
}
.titulo-empresa h1 {
  font-size: 16px;
  color: #36508e;
  font-weight: 800;
  margin: 0;
  line-height: 110%;
}
.sponsor {
  color: grey;
  font-size: 12px;
}
.sponsor a {
  color: #ff5722;
}
.imagen-destacada {
  height: 246px;
}
#preview-img {
  position: relative;
  left: -5%;
}

#preview-img img {
  width: 110% !important;
}
.descripcion-contenedor {
  border-bottom: 1px solid #c5c5c5;
  border-right: 1px solid #c5c5c5;
  border-left: 1px solid #c5c5c5;
  padding: 10px;
  height: auto;
  margin-boton: 100px;
  position: relative;
}
.addTitle {
  font-size: 19px;
  margin: 10px 0;
  line-height: 110%;
  font-weight: 400;
  color: rgb(76, 76, 76);
}
.link-anuncio {
  text-transform: uppercase;
  color: #929292;
  margin-top: 10px;
  font-size: 12px;
}
.call-to-action {
  font-size: 11px;
  background-color: #f8f8f8;
  color: #797979;
  border: 1px solid #797979;
  border-radius: 2px;
  padding: 4px 5px;
  transition: all 0.3s ease-in-out;
  height: auto;
  line-height: 12px;
  position: relative;
  left: 12%;
}

#fecha-input{
    border: none !important;
    width: 100% !important;
    text-align: center !important;
    height: 30px !important;
    border-radius: 5px !important;
}

.interaccion {
  list-style: none;
  margin: 0;
  padding: 0;
}
.interaccion li {
  display: inline-block;
  color: #929292;
  margin-right: 10px;
  font-size: 15px;
}
.icono-error {
  font-size: 35px;
  color: #ff3547;
}
.icono-crear {
  color: rgb(32, 160, 255);
  cursor: pointer;
  font-size: 16px;
  padding-left: 5px;
}
.boton-pregunta {
  background: transparent !important;
  border: none;
  box-shadow: none;
  padding: 0px;
}

.modal-body{
  overflow-y: auto;
  height: 400px;
}



.checkbox-2{
  height: 20px;
    position: absolute;
}

.carrousel-test{
  height: 400px;
}

.video-component{
  height: 350px;
}

.contener-completo {
  width: 100%;
  height: 230px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.VueCarousel-navigation-prev {
  padding-right: 18px !important;
}

.VueCarousel-navigation-next{
  padding-left: 18% !important;
}


.VueCarousel, .VueCarousel .VueCarousel-inner{
  height: 100% !important;
}

.contener-completo .VueCarousel-inner{
  height: 100% !important;
}

</style>